import type { QueryClient } from '@tanstack/react-query';

export function withoutDiscoveryProfile<T extends { cards: Array<{ id: string }> }>(
  current: T | undefined,
  profileId: string,
): T | undefined {
  return current
    ? { ...current, cards: current.cards.filter((card) => card.id !== profileId) }
    : current;
}

export function withoutIncomingLikeProfile<T extends { items: Array<{ profile: { id: string } }> }>(
  current: T | undefined,
  profileId: string,
): T | undefined {
  return current
    ? { ...current, items: current.items.filter((item) => item.profile.id !== profileId) }
    : current;
}

export function withDiscoveryProfileAt<T extends { cards: Array<{ id: string }> }>(
  current: T | undefined,
  profile: T['cards'][number],
  index: number,
): T | undefined {
  if (!current || current.cards.some((card) => card.id === profile.id)) return current;
  const cards = [...current.cards];
  cards.splice(Math.min(Math.max(index, 0), cards.length), 0, profile);
  return { ...current, cards };
}

export function clearLocalAcceptanceSessionQueries(queryClient: QueryClient): void {
  queryClient.clear();
}

export function clearPostOnboardingQueries(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: ['discovery'] });
  queryClient.removeQueries({ queryKey: ['likes'] });
}

export function clearMatchedProfileCaches(queryClient: QueryClient, profileId: string): void {
  queryClient.setQueryData(['discovery'], (current: { cards: Array<{ id: string }> } | undefined) =>
    withoutDiscoveryProfile(current, profileId),
  );
  void queryClient.invalidateQueries({ queryKey: ['discovery'] });
  void queryClient.invalidateQueries({ queryKey: ['likes'] });
}
